import { render } from "./GoToTop.vue?vue&type=template&id=4ea48034&scoped=true"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"

import "./GoToTop.vue?vue&type=style&index=0&id=4ea48034&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea48034"]])

export default __exports__